import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, AutoComplete, message } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import { CompanySelection } from 'kts-platform-frame/display/part';
import moment from 'moment';
import ModulesFormAction from './Modules.Form.Action';

const Option = Select.Option;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { form } = this.props; // 获取你的props数
        const { getFieldDecorator } = form;
        const forecastForm = this.modulesState.forecastForm;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17 },
            },
        };
        const dateFormat = this.modulesState.dateFormat;
        const messageInfos = this.modulesState.messageInfos;
        return (
            <Form className="form">
                <Row>
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="采购方"
                        >
                            {getFieldDecorator('SenderParty', {
                                initialValue: forecastForm.SenderParty.ID,
                                rules: [{
                                    required: true,
                                    message: '',
                                }],
                            })(
                                <span>{forecastForm.SenderParty.Name}</span>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="采购联系人"
                        >
                            {getFieldDecorator('SenderContact', {
                                initialValue: forecastForm.SenderContact.ID,
                                rules: [],
                            })(
                                <span>{forecastForm.SenderContact.Name}</span>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="销售方"
                        >
                            {getFieldDecorator('ReceiverParty', {
                                initialValue: forecastForm.ReceiverParty.Name,
                                rules: [{
                                    required: true,
                                    message: '请选择销售方',
                                }],
                            })(
                                <Input
                                    readOnly={true}
                                    placeholder=""
                                    onFocus={this.getonFocus}
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'ReceiverParty',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ReceiverParty'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="销售联系人"
                        >
                            {getFieldDecorator('ReceiverContact', {
                                initialValue: forecastForm.ReceiverContact.Name,
                                rules: [{
                                    required: false,
                                    message: '',
                                    ...ModulesAction.getExtraRules('ReceiverContact')
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'ReceiverContact',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ReceiverContact'))}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="计划编号"
                        >
                            {getFieldDecorator('ID', {
                                initialValue: forecastForm.ID,
                                rules: [{
                                    required: true,
                                    //规则注释 pattern: /^.{0,50}$/,
                                    //规则注释 message: '必填，支持不超过50个字符',
                                    message: '必填',
                                    ...ModulesAction.getExtraRules('ID')
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'ID',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ID'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="填报时间"
                        >
                            {getFieldDecorator('IssueDate', {
                                initialValue: ModulesAction.timeStampToFormat(forecastForm.IssueDate),
                                rules: [{
                                    required: true,
                                    message: '请选择时间',
                                }],
                            })(
                                <DatePicker
                                    showTime={{ format: this.modulesState.timeFormat }}
                                    placeholder=""
                                    style={{ width: '100%' }}
                                    format={dateFormat}
                                    disabledDate={ModulesAction.disabledDate}
                                    onChange={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'IssueDate',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: moment(e).valueOf(),
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('IssueDate'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="有效期"
                        >
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('ForecastPeriodStartDate', {
                                        initialValue: ModulesAction.timeStampToFormat(forecastForm.ForecastPeriod.StartDate),
                                    })(
                                        <DatePicker
                                            showTime={{ format: this.modulesState.timeFormat }}
                                            placeholder=""
                                            style={{ width: '100%' }}
                                            format={dateFormat}
                                            disabledDate={this.disabledStartDate}
                                            onChange={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'ForecastPeriodStartDate',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: moment(e).valueOf(),
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('ForecastPeriodStartDate'))}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                    至
                                </span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('ForecastPeriodEndDate', {
                                        initialValue: ModulesAction.timeStampToFormat(forecastForm.ForecastPeriod.EndDate),
                                    })(
                                        <DatePicker
                                            showTime={{ format: this.modulesState.timeFormat }}
                                            placeholder=""
                                            style={{ width: '100%' }}
                                            format={dateFormat}
                                            disabledDate={this.disabledEndDate}
                                            onChange={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'ForecastPeriodEndDate',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: moment(e).valueOf(),
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('ForecastPeriodEndDate'))}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }
    /**
     * 获取焦点展开搜索 公司
     */
    private getonFocus = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <CompanySelection
                showSearch={true}
                isCheck={false}
                onSubmitCompany={this.onSubmitCompany}
                request={ModulesAction.pageListUsersList}
            />,
            title: '企业选择'
        });
    }
    /** 选择公司后的保存 */
    private onSubmitCompany = (data: any) => {
        if (data.length) {
            this.props.form.setFieldsValue({ ReceiverParty: data[0].connectionName });
            ModulesAction.saveSellerSupplie(data);
            // 关闭右侧弹窗
            MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, {
                title: '企业选择',
                isHide: true,
            });
        } else {
            message.warning('请企业选择');
        }

    }

    /** 开始时间限制 */
    private disabledStartDate = (startValue) => {
        const endValue = this.props.form.getFieldValue("ForecastPeriodEndDate");
        if (!startValue || !endValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
    /**
     * 结束时间限制
     */
    private disabledEndDate = (endValue) => {
        const startValue = this.props.form.getFieldValue("ForecastPeriodStartDate");
        if (!endValue || !startValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.ForecastFormBasicInfo.tsx